import { createEntityAdapter } from '@fullstory/redux-util';
import { Annotation } from '@fullstory/proto/fs/services/dx-objects';

export const annotationsAdapter = createEntityAdapter<Annotation, Annotation['id']>({
  selectId: annotation => annotation.id,
});
